import type { MappingData } from "api/fetchCommon";
import { toNumberOrNull } from "utils/achievementConfigForm";
import { getMappingLabel } from "utils/mappingLabel";

export type RiskMarginItem = {
    groupId: string;
    label: string;
    text: string; // 表示用（例 "aco: 3.0 dB"）
};

// 整数は小数 1 桁（3 → "3.0"）。非整数は丸めると設定画面で入力した値とずれるため、そのまま出す。
export const formatRiskMarginValue = (value: number): string =>
    Number.isInteger(value) ? value.toFixed(1) : String(value);

// 判断表 GET の risk_margin（現象グループ別、dB）を表示項目に変換する。
// 並び順は groupIds（設定画面と同じ ACHIEVEMENT_GROUP_IDS）で決め、レスポンスのキー順には依らない。
// groupIds に無いキー・欠落・非数値は出さず、想定外の形でも落とさない。
export const buildRiskMarginItems = (
    riskMargin: Record<string, unknown> | null | undefined,
    groupIds: readonly string[],
    mapping: MappingData | null,
): RiskMarginItem[] => {
    if (typeof riskMargin !== "object" || riskMargin === null || Array.isArray(riskMargin)) return [];
    return groupIds.flatMap((groupId) => {
        const value = toNumberOrNull(riskMargin[groupId]);
        if (value === null) return [];
        const label = getMappingLabel(mapping, "condition_group_id", groupId);
        return [{ groupId, label, text: `${label}: ${formatRiskMarginValue(value)} dB` }];
    });
};
